import { Component } from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import {
  setTargetOrigin,
  addInitListener,
  addContextUpdateListener,
  removeContextUpdateListener,
  sendCustomMessage,
  removeInitListener,
} from '@luigi-project/client';
import './index.css';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/js/dist/dropdown';
import AppWithRouterAccess from './okta/AppWithRouterAccess';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navVisible: false,
    };
    this.initListener = null;
    this.contextUpdateListener = null;
    this.CustomMessageListener = null;

    addInitListener(() => {
      console.log('Luigi Client initialized.');
    });
    process.env.BABEL_ENV = process.env.NODE_ENV;
    process.on('unhandledRejection', err => {
      throw err;
    });
  }

  setEnvForLuigi() {
    if (process.env.REACT_APP_ENV !== undefined) {
      localStorage.setItem('env', process.env.REACT_APP_ENV);
    } else {
      if (process.env.NODE_ENV !== undefined) {
        localStorage.setItem('env', process.env.NODE_ENV);
      }
    }
    setTargetOrigin(window.location.origin);
    sendCustomMessage({
      id: 'controlpoint.send',
      value: {
        id: 'set.env',
        value: process.env.REACT_APP_ENV,
      },
    });
  }
  componentDidMount() {
    this.setEnvForLuigi();

    this.initListener = addInitListener(initialContext => {
      this.setState({
        message: 'Luigi Client initialized.',
      });
    });
    this.contextUpdateListener = addContextUpdateListener(updatedContext => {
      console.log(updatedContext);
      this.setState({
        message: 'Luigi Client updated.',
      });
    });
    this.setState(state => ({
      navVisible: true,
    }));
  }

  componentWillUnmount() {
    this.setEnvForLuigi();
    removeContextUpdateListener(this.contextUpdateListener);
    removeInitListener(this.initListener);
  }

  render() {
    return (
      <Router>
        {this.state.navVisible && <AppWithRouterAccess></AppWithRouterAccess>}
      </Router>
    );
  }
}

render(<App />, document.getElementById('nav'));
